import React, { Fragment, useState } from 'react';
import Swal from 'sweetalert2';

import { useAuth } from '../../Context/Context';

import SideNav from '../../Components/SideNav';
import Loader from '../../Components/Loader';
import ListaAdmin from '../../Components/ListaAdmin';
import FilaAdmin, { Insignia } from '../../Components/FilaAdmin';
import PanelEdicion from '../../Components/PanelEdicion';
import SeccionPanel from '../../Components/SeccionPanel';

import useListaAdmin from '../../Hooks/useListaAdmin';

const VACIO = { nombre: '' };
const CAMPOS_BUSQUEDA = ['nombre'];

const estiloAyuda = { color: "#757575", fontSize: "13px", margin: "-10px 0 10px" };

const normalizar = texto => String(texto ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

// Etiquetas de cursos y de blogs: misma pantalla, cambia el helper y dónde se usan.
// usadoEn: { singular, plural } de lo que usa la etiqueta ('curso' / 'cursos')
const VistaEtiquetas = ({ helper, seccion, encabezado, usadoEn, ubicacion }) => {
    const { recargar } = useAuth();
    const [guardando, setGuardando] = useState(false);

    const l = useListaAdmin({ obtener: helper.obtenerEtiquetas, obtenerUso: helper.obtenerUso, vacio: VACIO, camposBusqueda: CAMPOS_BUSQUEDA });

    const cuantos = n => n + ' ' + (n === 1 ? usadoEn.singular : usadoEn.plural);
    const enUso = l.editar ? l.uso[l.editar._id] ?? 0 : 0;
    const agregando = l.panel.abierto === 'agregar';

    const guardar = async e => {
        e.preventDefault();
        const nombre = l.borrador.nombre.trim();
        if (!nombre) return Swal.fire('Error!', 'Escribe el nombre de la etiqueta', 'error');
        const repetida = l.todos.find(etiqueta => etiqueta._id !== l.editar?._id && normalizar(etiqueta.nombre) === normalizar(nombre));
        if (repetida) return Swal.fire('Error!', 'Ya existe la etiqueta "' + repetida.nombre + '"', 'error');
        setGuardando(true);
        const res = agregando ? await helper.agregarEtiqueta({ nombre }) : await helper.editarEtiqueta({ nombre }, l.editar._id);
        if (res?.success) return recargar();
        setGuardando(false);
    }

    const eliminar = async () => {
        const { isConfirmed } = await Swal.fire({
            icon: 'question',
            titleText: '¿Eliminar la etiqueta "' + l.editar.nombre + '"?',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });
        if (!isConfirmed) return;
        setGuardando(true);
        const res = await helper.eliminarEtiqueta(l.editar._id);
        if (res?.success) return recargar();
        setGuardando(false);
    }

    return (
        <Fragment>
            <SideNav />
            {guardando && (
                <div style={{width:"100%", height:"100vh", position:"fixed", top:"0", background:"#00000059", zIndex:"9999"}}>
                    <Loader />
                </div>
            )}
            <div className='row'>
                <PanelEdicion
                    abierto={Boolean(l.panel.abierto)}
                    titulo={agregando ? 'Agregar etiqueta' : 'Editar etiqueta'}
                    ancho={l.panel.ancho}
                    onArrastre={l.panel.iniciarArrastre}
                    onCerrar={() => l.panel.cerrar()}
                    hayCambios={l.hayCambios}
                    pie={
                        <Fragment>
                            {!agregando && (
                                <button type='button' className='boton_admin boton_admin_peligro' onClick={eliminar} disabled={enUso > 0}>
                                    Eliminar
                                </button>
                            )}
                            <button type='submit' form='form_etiqueta' className='boton_admin' disabled={!l.hayCambios}>
                                {agregando ? 'Agregar etiqueta' : 'Guardar cambios'}
                            </button>
                        </Fragment>
                    }
                >
                    {l.panel.abierto && (
                        <form id='form_etiqueta' key={l.version} onSubmit={guardar}>
                            <SeccionPanel id='nombre' numero={1} titulo='Nombre' ubicacion={ubicacion}>
                                <div className="input-field">
                                    <input onChange={e => l.cambiar({ nombre: e.target.value })} value={l.borrador.nombre} id='etiqueta_nombre' type="text" maxLength={100} autoFocus />
                                    <label className='active' htmlFor='etiqueta_nombre'>Nombre de la etiqueta</label>
                                </div>
                            </SeccionPanel>
                            {!agregando && (
                                <SeccionPanel id='uso' numero={2} titulo='Uso'>
                                    {enUso > 0 ? (
                                        <p className='panel_aviso'>Se usa en {cuantos(enUso)}. Para eliminarla, primero quítala de esos {usadoEn.plural}; cambiarle el nombre sí se puede.</p>
                                    ) : (
                                        <p style={{ ...estiloAyuda, margin: "0 0 6px" }}>Ningún {usadoEn.singular} la usa; se puede eliminar.</p>
                                    )}
                                </SeccionPanel>
                            )}
                        </form>
                    )}
                </PanelEdicion>
                <ListaAdmin
                    etiqueta={seccion}
                    encabezado={encabezado}
                    ayuda={`Haz clic en una etiqueta para editarla. Las que usa algún ${usadoEn.singular} no se pueden eliminar.`}
                    acciones={
                        <button type='button' className='boton_admin' onClick={l.abrirAgregar}>
                            + Agregar etiqueta
                        </button>
                    }
                    busqueda={l.busqueda}
                    onBusqueda={l.setBusqueda}
                    placeholder='Buscar etiqueta'
                    total={l.todos?.length ?? 0}
                    mostrados={l.lista?.length ?? 0}
                    cargando={l.cargando}
                    textoVacio='Aún no hay etiquetas.'
                    margen={l.panel.abierto ? l.panel.ancho : 0}
                >
                    {l.lista?.map(etiqueta => {
                        const n = l.uso[etiqueta._id] ?? 0;
                        return (
                            <FilaAdmin
                                key={etiqueta._id}
                                activa={l.editar?._id === etiqueta._id}
                                onClick={() => l.abrirEditar(etiqueta)}
                                icono='sell'
                                titulo={etiqueta.nombre}
                                insignias={<Insignia variante={n ? null : 'gris'}>{n ? 'En ' + cuantos(n) : 'Sin uso'}</Insignia>}
                            />
                        );
                    })}
                </ListaAdmin>
            </div>
        </Fragment>
    );
}

export default VistaEtiquetas;
